import { useEffect, useRef } from 'react'
import './Modal.css'

const Modal = ({ isOpen, onClose, title, children, modalClassName }) => {
  const overlayRef = useRef(null)
  const mouseDownTarget = useRef(null)

  // Close with ESC key and manage body overflow
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose()
    }
    if (isOpen) {
      document.addEventListener('keydown', handleEsc)
      // Store original overflow value
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      
      return () => {
        document.removeEventListener('keydown', handleEsc)
        // Restore to original or 'hidden' (as per index.css)
        document.body.style.overflow = originalOverflow || 'hidden'
      }
    }
  }, [isOpen, onClose])

  // Track where mousedown started
  const handleMouseDown = (e) => {
    mouseDownTarget.current = e.target
  }

  // Only close if mousedown AND mouseup were both on the overlay
  const handleMouseUp = (e) => {
    if (
      mouseDownTarget.current === overlayRef.current && 
      e.target === overlayRef.current
    ) {
      onClose()
    }
    mouseDownTarget.current = null
  }

  if (!isOpen) return null

  return (
    <div 
      className="modal-overlay" 
      ref={overlayRef}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      translate="no"
    >
      <div className={`modal ${modalClassName || ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal__header">
          <h2 className="modal__title">{title}</h2>
          <button className="modal__close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal__content">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
